import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  INTERNAL_ARTICLES_CREATE,
  INTERNAL_ARTICLES_EDIT,
} from '../../../router/routes';
import { useService } from '../../../services/services';
import { ArticleStatus } from '../../../enums/article-status';
import Article from '../../../interfaces/article';
import Table from '../../../components/common/table/table';
import { DefaultFilter } from '../../../components/common/table/default-filter';
import Title from '../../../components/common/title';
import { LinkComponent as Link } from '../../../components/form/elements/link';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import css from './index.module.css';
import FieldTypes from '../../../enums/field-types';

export default function Articles() {
  const { t } = useTranslation();
  const tp = useCallback(
    (key: string) => t('pages.internal.articles.'.concat(key)),
    [t]
  );
  const { articleService } = useService();

  const request = useCallback(
    (page: number, sort: string, desc: boolean, filter: any) =>
      articleService.index({ page, sort, desc, ...filter }),
    [articleService]
  );

  const [statusFilter] = useState([
    { label: tp('status.public'), value: ArticleStatus.PUBLIC },
    { label: tp('status.internal'), value: ArticleStatus.INTERNAL },
  ]);

  return (
    <div className={css['index']}>
      <Title title={tp('title')} />

      <div className={css['body']}>
        <div className={css['toolbar']}>
          <Link
            label="add"
            primary={true}
            linkTo={INTERNAL_ARTICLES_CREATE}
            icon={faPlus}
          />
        </div>

        <Table<Article>
          request={request}
          keyAccessor="id"
          columns={[
            {
              accessor: 'category',
              header: tp('table.category'),
              dataType: FieldTypes.MULTI_SELECT_VALUE,
              translatable: (key: string) => {
                return t(key);
              },
              sortable: true,
            },
            { accessor: 'title', header: tp('table.title') },
            {
              accessor: 'created_at',
              header: tp('table.created_at'),
              sortable: true,
            },
            {
              accessor: 'status',
              header: tp('table.status'),
              filter: <DefaultFilter options={statusFilter} name="status" />,
              dataType: FieldTypes.TEXT,
              translationPrefix: 'pages.internal.articles.status.',
              translatable: (key: string) => {
                return t(key);
              },
            },
          ]}
          viewRoute={INTERNAL_ARTICLES_EDIT}
          viewRecordAbility={{ title: 'Manage articles' }}
        />
      </div>
    </div>
  );
}
